@if (isEnumerated()) {
  <ol class="list-decimal list-inside">
    @for (item of items(); track item) {
      <li>{{ item.body }}</li>
    }
  </ol>

} @else {
  <ul class="list-disc list-inside">
    @for (item of items(); track item) {
      <li>{{ item.body }}</li>
    }
  </ul>
}
